export default __webpack_public_path__ + "static/media/at (5).b57193fc.jpg";